/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Group_AssignInputs */

const vi_customer_group_assign = /** @type {(inputs: Customer_Group_AssignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm vào nhóm`)
};

/**

* @param {Customer_Group_AssignInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_group_assign = /** @type {((inputs?: Customer_Group_AssignInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Group_AssignInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_group_assign(inputs)
});